export const generateStepLabel = (stepNo: number | string, stepName: string) =>
  `Step ${stepNo} - ${stepName}`;

export const parseReference = (
  reference?:
    | {
        code: number;
        label?: string | null;
        description?: string | null;
      }
    | null
    | ""
) =>
  reference
    ? `${reference.code}:${reference.label || reference.description || ""}`
    : "";

export const parseReferences = (
  reference?:
    | Array<{
        code: number;
        label?: string | null;
        description?: string | null;
      }>
    | null
    | ""
) => {
  return reference && reference.length > 0
    ? reference
        .map(
          (reference) =>
            `${reference.code}:${
              reference.label || reference.description || ""
            }`
        )
        .join("||")
    : "";
};
